export const Analytics = {
  isAvailable () {
    return !!window['analytics'] || !!window['dataLayer']
  },
  identify (userId, user) {
    window['analytics'] && window['analytics'].identify(userId, user)
  },
  page (name, path) {
    window['analytics'] && window['analytics'].page(name, {
      path
    })
    window['dataLayer'] && window['dataLayer'].push({
      event: 'content-view',
      'content-name': path
    })
  },
  track (event, params) {
    window['analytics'] && window['analytics'].track(event, params)
  }
}
